import React, { useEffect } from "react";

import Main from '../components/Trading/Main'
import AdvancedCharting from "../components/Trading/AdvancedCharting";
import WhatToTrade from "../components/Trading/WhatToTrade";
import TradeOn from "../components/Trading/TradeOn";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function Trading () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">
            <Main/>
            <AdvancedCharting/>
            <WhatToTrade/>
            <TradeOn/>
            <YourTradingJourney/>
        </div>
    );
}

export default Trading;